/* global google */
import createSimplePrivateGallery from '@PROJECT_ROOT/assets/desktop/js/search/simplePrivateGallery';
import getAdriaticStyles from '@PROJECT_ROOT/assets/shared/js/map/GoogleMapsStyles';
import guideBeachRivieraMap, { cleanMarkers, putMarkersOnMap } from '@PROJECT_ROOT/assets/desktop/js/guide/guideBeachRivieraMap';
import guideGeoBeachSearch from '@PROJECT_ROOT/assets/desktop/js/guide/guideGeoBeachSearch';

guideGeoBeachSearch(); // Prikaz regija i rivijera

$(() => {
    setUpGalleries();
    beachCategoriesShow();
    const $pageLoader = $('#pageLoader');
    const bounds = new google.maps.LatLngBounds();
    const mapElement = document.getElementById('beachRivieraMap');
    let markers = [];
    let beachRivieraMap = null;

    if (mapElement) {
        const mapOptions = {
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: getAdriaticStyles(),
        };

        beachRivieraMap = new google.maps.Map(document.getElementById('geo_map_canvas'), mapOptions);
        guideBeachRivieraMap(mapElement, markers, beachRivieraMap, bounds); // Prikaz zadane rivijere s markerima
    }

    $('.beachType').on('change', () => {
        const $beachSearchForm = $('#beachSearchForm');
        $pageLoader.show();

        $.get($beachSearchForm.data('searchbeachesurl'), $beachSearchForm.serialize())
            .then(
                (response) => {
                    $('#beachesSearchResult').html(response.beachesSearchResult);

                    if (window.history.replaceState) {
                        window.history.replaceState({}, '', response.contentUrl);
                    }

                    setUpGalleries();
                    beachCategoriesShow();
                    if (mapElement) {
                        cleanMarkers(markers);
                        markers = [];
                        const dataMarkers = JSON.parse(response.markers);
                        putMarkersOnMap(beachRivieraMap, markers, dataMarkers, bounds, mapElement);
                    }
                    $pageLoader.hide();
                },
                () => $pageLoader.hide(),
            );
    });
});

function setUpGalleries() {
    $('.beachSimpleGallery').toArray().forEach((element) => {
        const $galleryContainer = $(element);
        createSimplePrivateGallery({
            source: $galleryContainer.data('source').map((image) => ({ url: image['300w200h'] })),
            nextButton: $galleryContainer.find('.simpleGalleryNext')[0],
            previousButton: $galleryContainer.find('.simpleGalleryPrev')[0],
            counterElement: $galleryContainer.find('.simpleGalleryCounter')[0],
            imageElement: $galleryContainer.find('.currentImage img')[0],
        });
    });
}

function beachCategoriesShow() {
    const beachCategories = $('.revealCategories');

    beachCategories.each((index, category) => {
        if (category.offsetHeight > 150) {
            const showMoreElement = document.createElement('span');
            showMoreElement.classList.add('showMore');
            category.classList.add('closed');
            category.appendChild(showMoreElement);
        }
    });

    $('.revealCategories.closed, .revealCategories.open').on('click', function toggleRevealCategories() {
        $(this).toggleClass('open', 100);
        $(this).toggleClass('closed', 100);
    });
}
